import { render, staticRenderFns } from "./Finance.vue?vue&type=template&id=865cc878"
import script from "./Finance.vue?vue&type=script&lang=ts"
export * from "./Finance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports